import { ReactNode } from 'react'

interface SectionProps {
  children: ReactNode
  className?: string
  id?: string
  narrow?: boolean
}

export function Section({ children, className = '', id, narrow = false }: SectionProps) {
  return (
    <section id={id} className={`py-16 md:py-24 ${className}`}>
      <div className={narrow ? 'container-narrow' : 'container-wide'}>
        {children}
      </div>
    </section>
  )
}

interface SectionHeaderProps {
  title: string
  subtitle?: string
  centered?: boolean
  className?: string
}

export function SectionHeader({ title, subtitle, centered = false, className = '' }: SectionHeaderProps) {
  return (
    <div className={`mb-14 ${centered ? 'text-center' : ''} ${className}`}>
      <h2 className="text-3xl md:text-4xl font-bold text-slate-900 text-balance">{title}</h2>
      {subtitle && (
        <p className="mt-5 text-lg text-slate-600 max-w-2xl text-balance leading-relaxed">
          {subtitle}
        </p>
      )}
    </div>
  )
}
